"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Hook extends Api_1.default {
    constructor(props) {
        super(props);
    }
    /**
     * Create a new hook on the given object. See the area for details.
     * @param ref_type
     * @param ref_id
     * @param attributes
     * @returns
     */
    create(ref_type, ref_id, attributes = {}) {
        const requestObj = {
            method: 'post',
            url: `/hook/${ref_type}/${ref_id}/`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Deletes the hook with the given id.
     * @param hook_id
     * @returns
     */
    delete(hook_id) {
        const requestObj = {
            method: 'delete',
            url: `/hook/${hook_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Returns the hooks on the object.
     * @param ref_type
     * @param ref_id
     * @returns
     */
    getFor(ref_type, ref_id) {
        const requestObj = {
            method: 'get',
            url: `/hook/${ref_type}/${ref_id}/`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Request the hook to be validated.
     * @param hook_id
     * @returns
     */
    verify(hook_id) {
        const requestObj = {
            method: 'post',
            url: `/hook/${hook_id}/verify/request`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Validates the hook using the code received from the verify call. On successful validation the hook will become active.
     * @param hook_id
     * @returns
     */
    validate(hook_id, attributes = {}) {
        const requestObj = {
            method: 'post',
            url: `/hook/${hook_id}/verify/validate`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Hook;
